{
  "404": {
    "title": "404",
    "sub_title": "Something's missing",
    "content": "This page you are looking for doesn’t exist, or has been moved.",
    "return_home_button": "Back Home"
  },
  "password": {
    "title": "Enter store password",
    "password_label": "Password*",
    "password_placeholder": "Enter password here",
    "password_submit": "Submit",
    "required": "(*) Denotes required field",
    "store_owner_content": "Are you the store owner?",
    "store_owner_link_content": "Log in here"
  },
  "general": {
    "accessibility": {
      "skip_to_content": "Skip to content",
      "close_modal": "Close modal dialog",
      "nav_footer": "Footer"
    },
    "meta": {
      "tags": "Tagged \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "form": {
      "quantity": "Quantity",
      "decrement": "Decrease quantity",
      "increment": "Increase quantity"
    },
    "newsletter": {
      "header": "Stay up to date on new releases, special offers and events.",
      "subscribe": "Subscribe",
      "placeholder": "Email*",
      "success": "Thanks for signing up!"
    },
    "pagination": {
      "next": "Next",
      "next_page": "Next page",
      "page": "Page {{ page_number }}",
      "previous": "Previous",
      "previous_page": "Previous page"
    }
  },
  "header": {
    "account": "Account",
    "logo": "Site Logo",
    "go_home": "Link to Homepage",
    "cart": "Cart",
    "search": "Search",
    "view_all": "View all results",
    "products": "Products",
    "collections": "Collections",
    "pages": "Pages",
    "suggestions": "Suggestions",
    "articles": "Articles",
    "product_count": "{{ product_count }} Products",
    "no_results": "No results for “{{ terms }}”",
    "menu": "Menu",
    "close": "Close",
    "close_menu": "Close menu",
    "back": "Back",
    "main_navigation": "Main navigation",
    "country_region": "Country/Region",
    "cancel": "Cancel",
    "clear_search": "Clear search",
    "close_search": "Close search"
  },
  "footer": {
    "general": {
      "copyright_html": "Copyright &copy; {{ year }} {{ shop_name }}."
    }
  },
  "mini_cart": {
    "title": "Your Cart",
    "item_count": {
      "one": "({{ count }} item)",
      "other": "({{ count }} items)"
    },
    "add_accessories": "Add Accessories",
    "checkout": "Checkout",
    "keep_shopping": "Keep Shopping",
    "free_shipping_message_html": "You're <strong>{{ amount }}</strong> away from FREE Shipping",
    "free_shipping_complete_message_html": "You've unlocked <strong>FREE Shipping</strong>"
  },
  "collections": {
    "no_matches": "Sorry, there are no products in this collection",
    "total_products": "{{ count }} Products",
    "viewing_products": "Viewing {{ viewed }} of {{ total }}",
    "view_more": "Show more",
    "general": {
      "sort_by": "Sort by"
    },
    "show_more": "Show more",
    "show_less": "Show less",
    "filters": "Filters",
    "clear": "Clear all",
    "apply": "Apply"
  },
  "products": {
    "regular_price": "Regular price",
    "sold_out": "Sold Out",
    "low_stock": "Low Stock",
    "on_sale": "On Sale",
    "on_sale_percent_html": "{{ percent }}% OFF",
    "on_sale_from_html": "On Sale from {{ price }}",
    "from_text_html": "From {{ price }}",
    "add_to_cart": "Add to Cart",
    "quick_add": "+ Add",
    "quickshop": "Quickshop",
    "view_full": "View full details",
    "quantity": "Quantity",
    "details": "Details",
    "included": "Included",
    "loading": "Loading...",
    "adding": "Adding...",
    "added": "Added!",
    "error": "Error"
  },
  "cart": {
    "page_title": "Cart",
    "remove": "Remove",
    "subtotal": "Subtotal",
    "original_price": "Original Price",
    "discounted_price": "Discounted Price"
  },
  "blog": {
    "article": {
      "author": "Author",
      "comment_meta_html": "{{ author }} on {{ date }}",
      "previous_page": "Previous page",
      "next_page": "Next page",
      "previous_story": "Previous Story",
      "next_story": "Next Story",
      "read_more": "Read More",
      "share": "Share this post",
      "share_facebook": "Share on Facebook",
      "share_twitter": "Share on X",
      "share_linkedin": "Share on LinkedIn",
      "share_pinterest": "Share on Pinterest",
      "story_navigation": "Story navigation"
    },
    "comments": {
      "title": "Leave a comment",
      "name": "Name",
      "email": "Email",
      "message": "Message",
      "post": "Post comment",
      "moderated": "Please note, comments must be approved before they are published",
      "success_moderated": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated.",
      "success": "Your comment was posted successfully! Thank you!",
      "with_count": {
        "one": "{{ count }} comment",
        "other": "{{ count }} comments"
      }
    },
    "general": {
      "all": "All",
      "categories": "Categories",
      "empty_blog": "Sorry, no posts here",
      "latest_article": "Latest Article",
      "load_more": "Load More",
      "read_time": "{{ read_time }} min read",
      "viewing_count": "Viewing {{ showing }} of {{ total }}"
    }
  },
  "structured_data": {
    "breadcrumbs": {
      "cart": "Cart",
      "collections": "Collections",
      "page": "Page {{ page }}",
      "search": "Search",
      "tags_html": "Tagged \"{{ tags }}\""
    }
  },
  "breadcrumbs": {
    "home": "Home"
  },
  "contact": {
    "form": {
      "name": "Name",
      "message": "Message",
      "post_success": "Thanks for contacting us. We'll get back to you as soon as possible.",
      "error_heading": "Please adjust the following:",
      "missing_fields": "Your form does not contain all the required fields. Please ensure both the message and email fields are added."
    }
  },
  "icons": {
    "account": "Account",
    "cart": "Cart",
    "search": "Search",
    "filter": "Filter",
    "chevron-left": "Left",
    "chevron-right": "Right",
    "caret": "Open",
    "refresh": "Refresh",
    "hamburger": "Menu",
    "close": "Close",
    "download": "Download",
    "play": "Play",
    "pause": "Pause",
    "loading": "Loading",
    "heart": "Heart",
    "plus": "Plus",
    "minus": "Minus",
    "instagram": "Instagram",
    "facebook": "Facebook",
    "twitter": "Twitter",
    "pinterest": "Pinterest",
    "snapchat": "Snapchat",
    "tiktok": "TikTok",
    "tumblr": "Tumblr",
    "vimeo": "Vimeo",
    "youtube": "TouTube",
    "linkedin": "LinkedIn",
    "mail": "Email",
    "check": "Included",
    "cross": "Not included",
    "check-circle": "Check",
    "x-circle": "Cross"
  },
  "video": {
    "play": "Play Animation",
    "pause": "Pause Animation",
    "watch": "Watch Video"
  },
  "onboarding": {
    "product": {
      "title": "Product title",
      "vendor": "Product vendor"
    },
    "no_entry_selected": "Select a content entry for this section in the theme editor."
  },
  "search_page": {
    "results": "Search results for",
    "no_results": "No results were found for",
    "article": "Article",
    "page": "Page"
  },
  "product_feed": {
    "no_complementary_products": "There are no complementary products",
    "pdp_only_message": "Complementary Products block and Related Products block can only be added on the PDP"
  },
  "product_comparison": {
    "table_label": "Product comparison table"
  },
  "gift_cards": {
    "issued": {
      "how_to": "Use the alphanumeric code below to redeem online, or the QR code for in-store purchases.",
      "title": "you've received a gift card for ",
      "remaining": "remaining",
      "add_to_apple_wallet": "Add to Apple Wallet",
      "copy_code": "Copy to clipboard",
      "copy_code_success": "Code added to clipboard",
      "expires": "Expires",
      "expired": "Gift Card Expired"
    }
  }
}
